import { ref } from 'vue'

interface Snackbar {
  show: boolean
  text: string
  color: string
  timeout: number
}

const snackbar = ref<Snackbar>({
  show: false,
  text: '',
  color: 'success',
  timeout: 2000
})

export function useSnackbar() {
  const showSuccess = (text: string) => {
    snackbar.value = {
      show: true,
      text,
      color: 'success',
      timeout: 1500
    }
  }

  const showError = (text: string) => {
    snackbar.value = {
      show: true,
      text,
      color: 'error',
      timeout: 2500
    }
  }

  const showWarning = (text: string) => {
    snackbar.value = {
      show: true,
      text,
      color: 'warning',
      timeout: 2000
    }
  }

  const showInfo = (text: string) => {
    snackbar.value = {
      show: true,
      text,
      color: 'info',
      timeout: 2000
    }
  }

  return {
    snackbar,
    showSuccess,
    showError,
    showWarning,
    showInfo
  }
} 